import { render, staticRenderFns } from "./LinkGroupsByClientIdDialog.vue?vue&type=template&id=4d4ad6ec&scoped=true&"
import script from "./LinkGroupsByClientIdDialog.vue?vue&type=script&lang=js&"
export * from "./LinkGroupsByClientIdDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4ad6ec",
  null
  
)

export default component.exports